import { render, staticRenderFns } from "./newLogistics.vue?vue&type=template&id=fe27b79a"
import script from "./newLogistics.vue?vue&type=script&lang=js"
export * from "./newLogistics.vue?vue&type=script&lang=js"
import style0 from "./newLogistics.vue?vue&type=style&index=0&id=fe27b79a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports